module.exports = __webpack_public_path__ + "static/img/40005 (4).42aa938.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40005 (4).webp
// module id = O8tZ
// module chunks = 14